import { render, staticRenderFns } from "./DismissedModal.vue?vue&type=template&id=0fb5ebc2&"
import script from "./DismissedModal.vue?vue&type=script&lang=js&"
export * from "./DismissedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports